"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var d3Selection = require("d3-selection");
var d3Format = require("d3-format");
var d3Axis = require("d3-axis");
var d3 = __assign({}, d3Selection, d3Format, d3Axis);
var Axis = /** @class */ (function (_super) {
    __extends(Axis, _super);
    function Axis(props) {
        var _this = _super.call(this, props) || this;
        _this.axis = null;
        _this.renderAxis = function (props) {
            var scale = props.scale, tickValues = props.tickValues, tickFormat = props.tickFormat;
            var node = _this.axis;
            var axis;
            switch (_this.props.orient) {
                case 'bottom':
                    axis = d3
                        .axisBottom(scale)
                        .tickValues(tickValues)
                        .tickFormat(tickFormat);
                    break;
                case 'left':
                    axis = d3
                        .axisLeft(scale)
                        .ticks(4)
                        .tickFormat(tickFormat);
                    break;
                default:
                    return;
            }
            d3.select(node).call(axis);
            if (node) {
                var newState = __assign({}, _this.state);
                newState.tickElements = Array.from(node.getElementsByTagName('g'));
                _this.setState(newState);
            }
        };
        _this.getAxisTick = function (index) {
            var thisXAxis = _this.axis;
            // var thisXAxis = document.getElementById('xAxis'); //get xAxis
            // below you get the transform value of the tick you want depending on number you pass
            // so you get the children of the xAxis i.e ticks and get their transform value
            var children = thisXAxis.children[index].attributes.transform.nodeValue;
            // as children is the whole translate string, i.e 'translate(124.555,0)' etc we have to split it
            // we know the x value is from index 10 to the first comma
            var thisXPos = children.substring(10, children.lastIndexOf(','));
            // return split string
            return thisXPos;
        };
        _this.axisRef = function (axis) {
            _this.axis = axis;
        };
        _this.state = { axis: null, tickElements: [] };
        return _this;
    }
    Axis.prototype.componentWillReceiveProps = function (nextProps) {
        this.renderAxis(nextProps);
    };
    Axis.prototype.componentDidMount = function () {
        this.renderAxis(this.props);
    };
    Axis.prototype.render = function () {
        var chartWidth = this.props.size.width;
        var size = this.props.size;
        var tickElements = this.state.tickElements;
        var HorizontalTickMarks = tickElements.map(function (tickElement, index) {
            var tickTransform = tickElement.attributes.transform.nodeValue;
            // Don't render the first or last y-grid line
            if (index === 0 || index === tickElements.length - 1) {
                return null;
            }
            return (React.createElement("g", { transform: tickTransform, key: tickTransform },
                React.createElement("line", { x2: size.padding, x1: chartWidth - size.padding * 2 })));
        });
        var classNames = 'axis';
        switch (this.props.orient) {
            case 'bottom':
                classNames = classNames + ' x-axis';
                break;
            case 'left':
                classNames = classNames + ' y-axis';
                break;
            default:
                break;
        }
        return (React.createElement("g", null,
            React.createElement("g", { className: classNames, ref: this.axisRef, transform: this.props.translate }),
            React.createElement("g", { className: "y-grid grid" }, HorizontalTickMarks)));
    };
    Axis.defaultProps = {
        tickFormat: d3.format('.3s')
    };
    return Axis;
}(React.Component));
exports.default = Axis;
//# sourceMappingURL=Axis.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/LineChart/Axis.js
// module id = 366
// module chunks = 0